import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSetting } from '../../../utilities/sharedHooks/settings';

const HelpCenterButton = () => {
  const { t: translate } = useTranslation();

  const [faqUrl] = useSetting('content_urls', 'content_url_faq');

  return (
    <>
      <a
        href={faqUrl}
        target="_blank"
        className="bg-lighter text-white d-flex justify-content-center align-items-center bg-white rounded-3 text-decoration-none cursor-pointer mb-4 px-3 pt-4 pb-4"
        rel="noreferrer">
        <div className="flex-row d-flex align-items-center justify-content-start w-100">
          <div className="col-1">
            <img
              style={{ width: '1.25rem', height: '1.25rem' }}
              src="./assets/images/chat.svg"
              alt="user"
            />
          </div>
          <div className="col-10 ps-3">
            <p className="fw-bold letter-spacing-2">{translate('support_center_btn_label')}</p>
          </div>
          <div className="col-1 d-flex justify-content-end ms-auto">
            <i
              style={{ width: '1rem' }}
              className="icon icon-arrow-next-navigation text-primary text-f4 cursor-pointer"
              aria-label={translate('support_center_btn_label')}
            />
          </div>
        </div>
      </a>
    </>
  );
};

export default HelpCenterButton;
